export default "__VITE_ASSET__ce26377b__"